import AdminUserList from "../../containers/AdminUsers/List";
import AdminUserEntry from "../../containers/AdminUsers";
import UserEntry from "../../containers/Users";
import UserList from "../../containers/Users/List";

const userRoutes = [
  {
    path: "/admin-users",
    exact: true,
    auth: true,
    component: AdminUserList
  },
  {
    path: "/admin-users/:type",
    exact: true,
    auth: true,
    component: AdminUserEntry
  },
  {
    path: "/admin-users/:type/:id",
    exact: true,
    auth: true,
    component: AdminUserEntry
  },
  {
    path: "/users",
    exact: true,
    auth: true,
    component: UserList
  },
  {
    path: "/users/:type",
    exact: true,
    auth: true,
    component: UserEntry
  },
  {
    path: "/users/:type/:id",
    exact: true,
    auth: true,
    component: UserEntry
  }
];

export default userRoutes;



// WEBPACK FOOTER //
// ./src/system/routes/modules/user.jsx